var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Footer"},[_vm._v(" © 杭州货吉达科技有限公司    "),_c('span',{staticClass:"beian",on:{"click":_vm.toPage}},[_vm._v("浙ICP备2025148314号")])])
}
var staticRenderFns = []

export { render, staticRenderFns }